var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTailoredFeature3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 247.25 110",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-7{fill:#019cae;}.cls-2,.cls-9{fill:none;}.cls-2{stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.26px;}.cls-3{fill:#fff;}.cls-4{fill:#fefdf8;}.cls-5{fill:#c0cdea;}.cls-6,.cls-7,.cls-9{isolation:isolate;}.cls-7,.cls-9{font-size:14px;font-family:Roboto-Bold, Roboto;font-weight:700;}.cls-8{letter-spacing:-0.03em;}.cls-9{stroke:#019cae;stroke-miterlimit:10;}.cls-10{fill:#f1c400;}.cls-11{fill:#cb2c30;}.cls-12{fill:#00685e;}.cls-13{fill:#343579;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_877",
    "data-name": "Group 877"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1773",
    "data-name": "Rectangle 1773",
    className: "cls-1",
    y: 6.06,
    width: 128.79,
    height: 97.87,
    rx: 9
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_870",
    "data-name": "Group 870"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_189",
    "data-name": "Ellipse 189",
    className: "cls-1",
    cx: 157.15,
    cy: 24.42,
    r: 10.34
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_869",
    "data-name": "Group 869"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_868",
    "data-name": "Group 868"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1145",
    "data-name": "Path 1145",
    className: "cls-2",
    d: "M160,25.9l-.69.69a1.11,1.11,0,0,1-1.58,0L155,23.81a1.12,1.12,0,0,1,0-1.59h0l.69-.69a1.16,1.16,0,0,0,0-1.62h0l-1-1a1.15,1.15,0,0,0-1.63,0h0l-.54.54a4.09,4.09,0,0,0,0,5.79l3.83,3.83a4.11,4.11,0,0,0,5.79,0h0l.54-.54a1.15,1.15,0,0,0,0-1.63h0l-1-1a1.15,1.15,0,0,0-1.63,0Z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_84",
    "data-name": "Line 84",
    className: "cls-2",
    x1: 155.67,
    y1: 21.54,
    x2: 153.04,
    y2: 18.91
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_85",
    "data-name": "Line 85",
    className: "cls-2",
    x1: 160.03,
    y1: 25.9,
    x2: 162.66,
    y2: 28.53
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_872",
    "data-name": "Group 872"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_190",
    "data-name": "Ellipse 190",
    className: "cls-1",
    cx: 157.15,
    cy: 53.29,
    r: 10.34
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_871",
    "data-name": "Group 871"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1146",
    "data-name": "Path 1146",
    className: "cls-3",
    d: "M158.85,54.51a1.11,1.11,0,0,0,.15.89.94.94,0,0,0,.74.29,1.16,1.16,0,0,0,.72-.27,2.34,2.34,0,0,0,.62-.74,4.5,4.5,0,0,0,.44-1.12,5.76,5.76,0,0,0,.16-1.43,4.81,4.81,0,0,0-.26-1.64,3.66,3.66,0,0,0-.76-1.31,3.5,3.5,0,0,0-1.22-.87,4.29,4.29,0,0,0-1.66-.31,4.82,4.82,0,0,0-1.41.21,5,5,0,0,0-2.28,1.5,5.45,5.45,0,0,0-.8,1.16,6.35,6.35,0,0,0-.68,2.87,5.83,5.83,0,0,0,.24,1.65,3.78,3.78,0,0,0,.72,1.32,3.35,3.35,0,0,0,1.18.89,4,4,0,0,0,1.63.32,4.89,4.89,0,0,0,.66-.05c.2,0,.41-.07.61-.12a3.27,3.27,0,0,0,.53-.17,2.67,2.67,0,0,0,.42-.2l.25.57a3.93,3.93,0,0,1-.62.3,5.21,5.21,0,0,1-1.95.38,4.72,4.72,0,0,1-1.89-.37,4,4,0,0,1-1.39-1,4.5,4.5,0,0,1-.86-1.52,6.18,6.18,0,0,1-.3-1.9,7,7,0,0,1,.81-3.27,6.53,6.53,0,0,1,.94-1.33,6.4,6.4,0,0,1,1.22-1,5.73,5.73,0,0,1,1.44-.67,5.64,5.64,0,0,1,1.63-.24,4.84,4.84,0,0,1,1.91.36,4.34,4.34,0,0,1,1.44,1,4.48,4.48,0,0,1,.9,1.5,5.45,5.45,0,0,1,.31,1.88,6.63,6.63,0,0,1-.08,1,6.9,6.9,0,0,1-.23,1,5.1,5.1,0,0,1-.39.9,3.65,3.65,0,0,1-.55.74,2.81,2.81,0,0,1-.72.5,2.23,2.23,0,0,1-.88.18,2.3,2.3,0,0,1-.58-.07,1.86,1.86,0,0,1-.43-.2,1.47,1.47,0,0,1-.31-.3,2,2,0,0,1-.22-.37,2.39,2.39,0,0,1-.72.54,1.84,1.84,0,0,1-.86.2h-.19a1.72,1.72,0,0,1-.63-.12,1.46,1.46,0,0,1-.49-.33,1.34,1.34,0,0,1-.32-.49,1.58,1.58,0,0,1-.12-.61v-.13a.53.53,0,0,1,0-.13l.38-2.78a2.08,2.08,0,0,1,.24-.7,2.24,2.24,0,0,1,1.11-1,2,2,0,0,1,.72-.14h.19a1.55,1.55,0,0,1,.81.2,1.4,1.4,0,0,1,.54.54l.51-.62h.25Zm-3.39-.12v.07a.22.22,0,0,0,0,.08.89.89,0,0,0,.07.36.85.85,0,0,0,.49.49.83.83,0,0,0,.38.07h.49a1.06,1.06,0,0,0,.43-.08,1.33,1.33,0,0,0,.65-.57,1.23,1.23,0,0,0,.14-.42l.4-2.87a.19.19,0,0,0,0-.07v-.08a1,1,0,0,0-.07-.36,1,1,0,0,0-.2-.3.77.77,0,0,0-.3-.19.94.94,0,0,0-.37-.07h-.5a1.11,1.11,0,0,0-.43.09,1.37,1.37,0,0,0-.65.56,1.3,1.3,0,0,0-.14.42Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_873",
    "data-name": "Group 873"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_191",
    "data-name": "Ellipse 191",
    className: "cls-1",
    cx: 157.15,
    cy: 82.06,
    r: 10.34
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1147",
    "data-name": "Path 1147",
    className: "cls-2",
    d: "M162.11,80.47c0,2.74-5,8.48-5,8.48s-5-5.74-5-8.48a5,5,0,0,1,9.92,0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_192",
    "data-name": "Ellipse 192",
    className: "cls-2",
    cx: 157.15,
    cy: 80.42,
    r: 2.69
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_876",
    "data-name": "Group 876"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_193",
    "data-name": "Ellipse 193",
    className: "cls-4",
    cx: 30.89,
    cy: 55.04,
    r: 21.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_875",
    "data-name": "Group 875"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1148",
    "data-name": "Path 1148",
    className: "cls-5",
    d: "M39,70.26a16.55,16.55,0,0,1-10.06,2.42,15,15,0,0,1-5.11-1.27l-.6-.27L22.9,71l-.29-.17-1.14-.67a16.14,16.14,0,0,1-2.06-1.62,17.77,17.77,0,0,1-1.8-1.88,19.67,19.67,0,0,1-1.49-2.12,9.4,9.4,0,0,1-.64-1.11l-.58-1.15A23.22,23.22,0,0,1,14,59.88a18.39,18.39,0,0,1-.19-10.23A17.24,17.24,0,0,1,29.39,37.21a19.84,19.84,0,0,1,2.67.06,17.68,17.68,0,0,1,2.61.5,17.21,17.21,0,0,1,4.82,2.13,16.79,16.79,0,0,1,3.89,3.49,16.13,16.13,0,0,1,2.53,4.46l-.17.08a17.62,17.62,0,0,0-7-6.83A16.75,16.75,0,0,0,15,50c-.13.39-.3.76-.4,1.16l-.31,1.18c-.08.4-.13.81-.2,1.22A9.88,9.88,0,0,0,14,54.82a13.31,13.31,0,0,0,.55,4.9,14.79,14.79,0,0,0,.86,2.33,14.26,14.26,0,0,0,1.27,2.13l.36.5.18.25.21.23.82.92a16.72,16.72,0,0,0,1.88,1.58A18.26,18.26,0,0,0,22.17,69a21.89,21.89,0,0,0,2.21,1,18.3,18.3,0,0,0,4.67,1.12,7.84,7.84,0,0,0,1.19.07,8,8,0,0,0,1.2,0l1.21-.07,1.2-.19a18.37,18.37,0,0,0,4.62-1.5Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_874",
    "data-name": "Group 874"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1149",
    "data-name": "Path 1149",
    className: "cls-5",
    d: "M43.06,66.38a27.23,27.23,0,0,1-8.86,1.3l3.9,2.5,1.4,4.42A27.45,27.45,0,0,1,43.06,66.38Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "LOGO",
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(10.91 57.85)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8"
  }, "L"), /*#__PURE__*/React.createElement("tspan", {
    x: 7.14,
    y: 0
  }, "OGO")), /*#__PURE__*/React.createElement("text", {
    className: "cls-9",
    transform: "translate(10.91 57.85)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8"
  }, "L"), /*#__PURE__*/React.createElement("tspan", {
    x: 7.14,
    y: 0
  }, "OGO")))), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1774",
    "data-name": "Rectangle 1774",
    className: "cls-1",
    d: "M191,17.85H246a1.31,1.31,0,0,1,1.3,1.31h0a1.3,1.3,0,0,1-1.3,1.3H191a1.3,1.3,0,0,1-1.3-1.3h0A1.31,1.31,0,0,1,191,17.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1775",
    "data-name": "Rectangle 1775",
    className: "cls-1",
    d: "M191,23.12H246a1.3,1.3,0,0,1,1.3,1.3h0a1.3,1.3,0,0,1-1.3,1.3H191a1.3,1.3,0,0,1-1.3-1.3h0A1.3,1.3,0,0,1,191,23.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1776",
    "data-name": "Rectangle 1776",
    className: "cls-1",
    d: "M191,28.38H246a1.3,1.3,0,0,1,1.3,1.3h0A1.3,1.3,0,0,1,246,31H191a1.3,1.3,0,0,1-1.3-1.3h0A1.3,1.3,0,0,1,191,28.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1777",
    "data-name": "Rectangle 1777",
    className: "cls-1",
    d: "M191,46.72H246a1.3,1.3,0,0,1,1.3,1.3h0a1.3,1.3,0,0,1-1.3,1.3H191a1.3,1.3,0,0,1-1.3-1.3h0A1.3,1.3,0,0,1,191,46.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1778",
    "data-name": "Rectangle 1778",
    className: "cls-1",
    d: "M191,52H246a1.31,1.31,0,0,1,1.3,1.31h0a1.3,1.3,0,0,1-1.3,1.3H191a1.3,1.3,0,0,1-1.3-1.3h0A1.31,1.31,0,0,1,191,52Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1779",
    "data-name": "Rectangle 1779",
    className: "cls-1",
    d: "M191,57.25H246a1.3,1.3,0,0,1,1.3,1.3h0a1.3,1.3,0,0,1-1.3,1.3H191a1.3,1.3,0,0,1-1.3-1.3h0A1.3,1.3,0,0,1,191,57.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1780",
    "data-name": "Rectangle 1780",
    className: "cls-1",
    d: "M191,77.46H246a1.3,1.3,0,0,1,1.3,1.3h0a1.31,1.31,0,0,1-1.3,1.31H191a1.31,1.31,0,0,1-1.3-1.31h0A1.3,1.3,0,0,1,191,77.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1781",
    "data-name": "Rectangle 1781",
    className: "cls-1",
    d: "M191,82.72H246a1.31,1.31,0,0,1,1.3,1.31h0a1.3,1.3,0,0,1-1.3,1.3H191a1.3,1.3,0,0,1-1.3-1.3h0A1.31,1.31,0,0,1,191,82.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1782",
    "data-name": "Rectangle 1782",
    className: "cls-1",
    d: "M191,88H246a1.3,1.3,0,0,1,1.3,1.3h0a1.3,1.3,0,0,1-1.3,1.3H191a1.3,1.3,0,0,1-1.3-1.3h0A1.3,1.3,0,0,1,191,88Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1783",
    "data-name": "Rectangle 1783",
    className: "cls-10",
    x: 62.18,
    y: 29.46,
    width: 52.7,
    height: 10.41
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1784",
    "data-name": "Rectangle 1784",
    className: "cls-11",
    x: 62.18,
    y: 42.59,
    width: 52.7,
    height: 10.41
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1785",
    "data-name": "Rectangle 1785",
    className: "cls-12",
    x: 62.18,
    y: 55.98,
    width: 52.7,
    height: 10.41
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1786",
    "data-name": "Rectangle 1786",
    className: "cls-13",
    x: 62.18,
    y: 68.81,
    width: 52.7,
    height: 10.41
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTailoredFeature3);
export default __webpack_public_path__ + "static/media/tailoredFeature3.2cb5679e31cf2c55039442db5b9254da.svg";
export { ForwardRef as ReactComponent };